module.exports = __webpack_public_path__ + "static/media/strongher16_preview.4a4a2f29.jpg";